import { Typography } from 'antd';
import dayjs from 'dayjs';
import { Sheet } from 'react-modal-sheet';
import styles from './index.module.css';
import { useContext, useMemo } from 'react';
import { AppContext } from '../../../../App';
import { formatToINR } from '../../../../Utils/utils';

const TransactionDetails: React.FC<{
  closeSheet: () => void;
  transaction: any;
}> = ({ closeSheet, transaction }) => {
  const { data }: any = useContext(AppContext);

  const account = useMemo(() => {
    if (
      data &&
      data.current &&
      data.current.ACCOUNT_DETAILS &&
      data.current.ACCOUNT_DETAILS.accountProfileList
    ) {
      const filteredBanks =
        data.current.ACCOUNT_DETAILS.accountProfileList.filter(
          (accountProfile: any) =>
            accountProfile.account.id === transaction.accountId
        );

      return filteredBanks.length > 0 && filteredBanks[0].account
        ? filteredBanks[0].account
        : null;
    } else {
      return null;
    }
  }, [transaction]);

  return (
    <Sheet
      className='accountDetailsSheet'
      isOpen={true}
      detent='content-height'
      onClose={closeSheet}
    >
      <Sheet.Backdrop onTap={closeSheet}></Sheet.Backdrop>
      <Sheet.Container>
        <div className={styles.accountDetails}>
          <div className={styles.closeIconContainer}>
            <div className={styles.closeIcon} onClick={closeSheet}>
              <Typography.Text style={{ color: '#fff', fontWeight: 500 }}>
                X
              </Typography.Text>
            </div>
          </div>

          <Typography.Text style={{ fontSize: 16, fontWeight: 700 }}>
            Transaction Details
          </Typography.Text>

          {transaction && transaction.narration ? (
            <div className={styles.accountDetaisListItem}>
              <Typography.Text className={styles.listItemHeader}>
                Narration
              </Typography.Text>
              <Typography.Text
                style={{ wordBreak: 'break-all' }}
                className={styles.listItemValue}
              >
                {transaction.narration}
              </Typography.Text>
            </div>
          ) : (
            <></>
          )}

          {/* {transaction && transaction.id ? (
            <div className={styles.accountDetaisListItem}>
              <Typography.Text className={styles.listItemHeader}>
                Transaction id
              </Typography.Text>
              <Typography.Text
                style={{ wordBreak: 'break-all' }}
                className={styles.listItemValue}
              >
                {transaction.id}
              </Typography.Text>
            </div>
          ) : (
            <></>
          )} */}

          {transaction && transaction.amount ? (
            <div className={styles.accountDetaisListItem}>
              <Typography.Text className={styles.listItemHeader}>
                Amount
              </Typography.Text>
              <Typography.Text
                style={{ wordBreak: 'break-all' }}
                className={styles.listItemValue}
              >
                {formatToINR(transaction.amount)}
              </Typography.Text>
            </div>
          ) : (
            <></>
          )}

          {transaction && transaction.type ? (
            <div className={styles.accountDetaisListItem}>
              <Typography.Text className={styles.listItemHeader}>
                Type
              </Typography.Text>
              <Typography.Text className={styles.listItemValue}>
                {transaction.type}
              </Typography.Text>
            </div>
          ) : (
            <></>
          )}

          {transaction && transaction.dateOfTransaction ? (
            <div className={styles.accountDetaisListItem}>
              <Typography.Text className={styles.listItemHeader}>
                Date & Time
              </Typography.Text>
              <Typography.Text className={styles.listItemValue}>
                {dayjs(transaction.dateOfTransaction).format("D MMM'YY h:mm A")}
              </Typography.Text>
            </div>
          ) : (
            <></>
          )}

          {transaction && transaction.counterParty ? (
            <div className={styles.accountDetaisListItem}>
              <Typography.Text className={styles.listItemHeader}>
                Counterparty
              </Typography.Text>
              <Typography.Text
                style={{ wordBreak: 'break-all' }}
                className={styles.listItemValue}
              >
                {transaction.counterParty}
              </Typography.Text>
            </div>
          ) : (
            <></>
          )}

          {transaction && transaction.paymentMode ? (
            <div className={styles.accountDetaisListItem}>
              <Typography.Text className={styles.listItemHeader}>
                Payment Mode
              </Typography.Text>
              <Typography.Text className={styles.listItemValue}>
                {transaction.paymentMode.replace(/_/g, ' ')}
              </Typography.Text>
            </div>
          ) : (
            <></>
          )}

          {account && account.fipId && account.bank ? (
            <div className={styles.accountDetaisListItem}>
              <Typography.Text className={styles.listItemHeader}>
                Bank
              </Typography.Text>
              <div
                style={{
                  display: 'flex',
                  gap: 8,
                }}
              >
                <div className={styles.fipImageSheet}>
                  <img
                    style={{
                      height: 15.9,
                      width: 'auto',
                      objectFit: 'contain',
                    }}
                    src={`https://logo.ignosis.ai/${
                      account.fipId ? account.fipId : ''
                    }.jpeg`}
                  />
                </div>
                <Typography.Text style={{ fontSize: 16, fontWeight: 600 }}>
                  {account.bank}
                </Typography.Text>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Sheet.Container>
    </Sheet>
  );
};

export default TransactionDetails;
